module.exports = __webpack_public_path__ + "static/media/be.6bd87048.svg";